import { useState } from "react";
import './Mission.css';

import { mission } from "../../../constants";
import { Heading } from "../../../components";



const MissionVision = () => {

    // State to manage the active tab (default is "mission")
    const [activeTab, setActiveTab] = useState("mission");

    return (
        <section className="tab-info mission-vision linear-bg">

            {/* Section Heading */}
            <Heading title={mission.heading} subTitle={mission.sub} linear />

            {/* Tab Buttons */}
            <div className="tab-buttons">
                {mission.sections.map(section => (
                    <button 
                        key={section.id} 
                        type="button" 
                        className={`button ${activeTab === section.id ? "active" : ""}`} // Add 'active' class if the tab is selected
                        onClick={() => setActiveTab(section.id)} // Update the active tab on click
                    >
                        {section.title} {/* Display the tab title (e.g., "Mission" or "Vision")*/}
                    </button>
                ))}
            </div>

            {/* Tab Sections: Display content based on the active tab */}
            <div className="tab-sections">
                {mission.sections.map(section => (
                    <div key={section.id} className={`tab-section ${activeTab === section.id ? "active" : ""}`}>
                        <div className="box-container">

                            {/* Content Section */}
                            <div className="content">

                                <Heading title={section.heading} subTitle={section.title} linear sideHeading />

                                <p>{section.description}</p> {/* Section description */}
                                <ul className="key-features">
                                    {/* Map over the points array to render key features */}
                                    {section.points.map((point, index) => (
                                        <li key={index}>
                                            <div className="icon">{point.icon}</div> {/* Feature icon */}
                                            <span>{point.title}</span> {/* Feature title */}
                                        </li>
                                    ))}
                                </ul>

                            </div>

                            {/* Displays the section image */}
                            <div className="image">
                                <img src={section.image} alt={section.title} />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default MissionVision;
